<div class="row">
  <div class="col-sm-4 form-group">
    <ep-weekday-selector [readonly]="readonly" [requireSelection]="requireWeekdaySelection" [(weekdays)]="trigger.Weekdays"
    (weekdaysChange)="changeTrigger()"></ep-weekday-selector>
  </div>
  @if (hideTriggerStart === false) {
    <div class="col-sm-2 form-group">
      <ep-datetime-picker #startTime [readonly]="readonly" type="time" [validateSelectedTime]="validateSelectedStartTime" [(selectedTime)]="trigger.StartTime"
      (selectedTimeChange)="changeTrigger()"></ep-datetime-picker>
    </div>
  }
  @if (hideTriggerEnd === false) {
    <div class="col-sm-2 form-group">
      <ep-datetime-picker #endTime [readonly]="readonly" type="time" [validateSelectedTime]="validateSelectedEndTime" [(selectedTime)]="trigger.EndTime"
      (selectedTimeChange)="changeTrigger()"></ep-datetime-picker>
    </div>
  }
  <div class="col-sm-3 form-group">
    <select class="form-control" [disabled]="readonly" [(ngModel)]="trigger.TimeZoneIdentifier" required>
      @for (tz of timeZoneService.timeZones(); track tz) {
        <option [ngValue]="tz.Identifier">{{tz.DisplayName}}</option>
      }
    </select>
  </div>
  <div class="col-sm-1 form-group">
    <button (click)="removeTrigger()" class="btn btn-link pull-right" [disabled]="readonly" title="Remove trigger">
      <ep-svg-icon icon="circle-cross"></ep-svg-icon>
    </button>
  </div>
</div>